function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());

const selectVariantByClickingImage = {
  _createVariantImage: function (product) {
    const variantImageObject = {};
    product.variants.forEach((variant) => {
      if (variant.featured_image) {
        const variantImage = variant.featured_image.src
          .split('?')[0]
          .replace(/http(s)?:/, '');
        variantImageObject[variantImage] = variantImageObject[variantImage] || {};
        product.options.forEach((option, index) => {
          const optionValue = variant.options[index];
          const optionKey = `option-${index}`;
          if (variantImageObject[variantImage][optionKey] === undefined) {
            variantImageObject[variantImage][optionKey] = optionValue;
          } else {
            const oldValue = variantImageObject[variantImage][optionKey];
            if (oldValue !== optionValue) {
              variantImageObject[variantImage][optionKey] = optionValue;
            }
          }
        });
      }
    });
    return variantImageObject;
  },
  _updateVariant: function (event, id, product, variantImages) {
    const arrImage = event.src
      .split('?')[0]
      .replace(/http(s)?:/, '')
      .split('.');
    const strExtension = arrImage.pop();
    const strRemaining = arrImage.pop();
    const strNewImage = `${arrImage.join('.')}.${strRemaining}.${strExtension}`;
    if (variantImages[strNewImage]) {
      product.options.forEach((option, index) => {
        const optionValue = variantImages[strNewImage][`option-${index}`];
        const selects = document.querySelectorAll(`#${id} [class*=select__select]`);
        if (option.toLowerCase() === 'color') {
          // Set color option to blank
          selects[index].selectedIndex = 0; // Assuming the first option is blank
          selects[index].dispatchEvent(new Event('change'));
        } else if (optionValue) {
          // Update other options normally
          const options = selects[index].options;
          for (let n = 0; n < options.length; n++) {
            if (options[n].value === optionValue) {
              selects[index].selectedIndex = n;
              selects[index].dispatchEvent(new Event('change'));
              break;
            }
          }
        }
      });
    }
  },
  _selectVariant: function () {
    const productJson = document.querySelectorAll('[id^=ProductJson-');
    if (productJson.length > 0) {
      productJson.forEach((product) => {
        const sectionId = product.id.replace("ProductJson-", "MainProduct-");
        const thumbnails = document.querySelectorAll(`#${sectionId} .thumbnail img`);
        if (thumbnails.length > 1) {
          const productObject = JSON.parse(product.innerHTML);
          const variantImages = this._createVariantImage(productObject);
          document.addEventListener('click', (e) => {
            if (e.target.classList.contains('thumbnail')) {
              this._updateVariant(e.target.querySelector('img'), sectionId, productObject, variantImages);
            }
          });
        }
      });
    }
  },
};

if (document.readyState !== 'loading') {
  selectVariantByClickingImage._selectVariant();
} else {
  document.addEventListener('DOMContentLoaded', selectVariantByClickingImage._selectVariant());
}
